import {BiLoggerFactory} from '@wix/wix-bi-logger-client';
import logger from './logger';

export const factory = logger.factory;
export const setHost = logger.setHost;

if (typeof window !== 'undefined') {
  Object.defineProperty(window, '$$BiLoggerClientFactory', {
    value: BiLoggerFactory,
    enumerable: false,
    writable: false
  });
}

export default logger;



// WEBPACK FOOTER //
// ./app.js